<div class="row">
  <div class="col-12">
    <lib-filter-list [configService]="accountRequestListConfigService"></lib-filter-list>
  </div>
</div>
